import { render, staticRenderFns } from "./Kelas.vue?vue&type=template&id=e25dd13c&"
import script from "./Kelas.vue?vue&type=script&lang=js&"
export * from "./Kelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports